unable to read source [project]/packages/src/components/icons/RightArrowIcon.tsx